import { RouteName, type RouteNameType } from './types';

import { ReviewType, type ReviewTypeValue } from '@/constants/review/CycleInstance';

export const getReviewFormRouteName = (reviewType?: ReviewTypeValue): RouteNameType => {
    if (reviewType === ReviewType.SELF_EVALUATION) {
        return RouteName.SelfAssessmentForm;
    }

    if (reviewType === ReviewType.MANAGER_EVALUATION) {
        return RouteName.ManagerAssessmentEvaluation;
    }

    return RouteName.Eval360Form;
};

export const getCycleRouteName = (reviewType?: ReviewTypeValue): RouteNameType => {
    if (reviewType === ReviewType.SELF_EVALUATION) {
        return RouteName.SelfAssessmentQuestionnaireTranslation;
    }

    return RouteName.Eval360QuestionnaireTranslation;
};
